import { useEffect, useState } from 'react'
import './style.scss'

/*
	Button which will appear over the page to provide functionality to scroll the page back to the top
*/

function BackToTopButton() {
	const [showButton, setShowButton] = useState<boolean>(false)

	useEffect(() => {
		window.onscroll = () => {
			if (window.scrollY < 500) {
				setShowButton(false)
			} else {
				setShowButton(true)
			}
		}
	})

	const scrollToTop = () => {
		window.scrollTo(0, 0)
	}

	return (
		showButton ? 
			<div className="back-to-top-button-wrap">
				<button 
					className='back-to-top-button'
					onClick={scrollToTop}
				>
					<img
						className='back-to-top-button-icon'
						src='/imgs/icons/icon-arrow-left.svg'
						alt='Back To Top Arrow'
					/>
				</button>
			</div>
		: <></>
	)
}

export default BackToTopButton